export enum DeadlineStates {
	Undefined = 'Undefined',
	FarFromDeadline = 'FarFromDeadline',
	NearDeadline = 'NearDeadline',
	DeadlinePassed = 'DeadlinePassed',
}
